import { TaxDetail } from "../../../services/Invoices/CreatorProfile/CreatorProfileService";
import { CustomField } from "./CustomFields";

export const mapCustomFieldsToJson = (fields: CustomField[]): string => {
	const mapped: Record<string, string> = {};
	const labelCount: Record<string, number> = {};

	fields.forEach((f) => {
		if (labelCount[f.label] === undefined) {
			labelCount[f.label] = 0;
		} else {
			labelCount[f.label]++;
		}

		const key = labelCount[f.label] === 0 ? f.label : `${f.label} (${labelCount[f.label]})`;
		mapped[key] = f.value;
	});

	return JSON.stringify(mapped);
};

export const mapBackendToCustomFields = (data: Record<string, string>): CustomField[] => {
	if (!data) return [];
	return Object.entries(data).map(([label, value]) => ({
		id: Date.now().toString() + Math.random(), // unique id
		label,
		value
	}));
};

export const mapTaxDetailsToCustomFields = (taxDetails: TaxDetail[]): CustomField[] => {
	return taxDetails.map((td) => ({
		id: Date.now().toString() + Math.random(),
		label: td.taxName,
		value: td.taxPercent.toString()
	}));
};
